import TextContainer from "./TextContainer";
import { useEffect, useState } from "react";
import { authorizedPut } from "../scripts/functions/AuthService";
import ConfirmationWindow from "./ConfirmationWindow";
import { useIsMobile } from "./Flexbox";
const ChangeForecastName = props => {

    const isMobile = useIsMobile();
    const displayLabel = props.forecast.displayName || props.forecast.prefix;
    const [newName, setNewName] = useState("");
    const [confirmation, setConfirmation] = useState(false);

    const handleChange = async () => {
        setConfirmation(false);

        try {
            const data = {
                forecast: props.forecast.prefix,
                newName: newName
            }

            const response = await authorizedPut("/forecast/changeName/", data)
            const resData = await response.body.json()
            // console.log("Response: ", response);
            
            if(response.statusCode >= 200 && response.statusCode < 300) {
                props.refresh();    //Call getAllForecasts to update the list
            } else {
                console.error("Error desconocido...", resData.error || resData);
                setNewName(displayLabel);
            }
        } catch (error) {
            console.error("Error changing the name:", error);
            setNewName(displayLabel);
        } 
    }

    const handleBlur = () => {
        if (!newName || newName === displayLabel) {
            return; 
        }

        setConfirmation(true);
    }

    const cancel = () => {
        setConfirmation(false);
        setNewName(displayLabel)
    }

    useEffect(() => {
        setNewName(displayLabel);
    }, [displayLabel])
 
    return (
        <>
            <TextContainer style={{width: isMobile ? '70%' : '316px', maxWidth: '316px', height: 40}} theme={props.theme} placeHolder={displayLabel} value={newName} onChange={setNewName} onBlur={handleBlur}/>
            {confirmation && (<ConfirmationWindow theme={props.theme} message={`Seguro que quieres cambiar el nombre del forecast de ${displayLabel} a ${newName}?`} action={handleChange} btnText={"Confirmar cambio"} onClose={cancel}/>)}
        </>
    )
}

export default ChangeForecastName;
